import { useEffect } from "react";
import { Desktop } from "./desktop";
import { Mobile } from "./mobile";
import type { DmmServiceReturnType } from "~/components/blocks/layout/global-navi/type";
import { convertServiceMenuOriginalTo } from "~/components/blocks/layout/global-navi/util/convert-service-menu-original-to";
import { dmmServiceListDataVar } from "~/components/blocks/layout/store";
import { useMatchMedia } from "~/hooks/use-match-media";
import { request } from "~/util/request";

export const GlobalNavi = () => {
  const { isPcSize } = useMatchMedia();

  useEffect(() => {
    (async () => {
      const { data } = await request.get<DmmServiceReturnType>(process.env.NEXT_PUBLIC_DMM_SERVICE_ENDPOINT);
      const items = convertServiceMenuOriginalTo(data);
      dmmServiceListDataVar(items);
    })();
  }, []);

  return isPcSize ? <Desktop /> : <Mobile />;
};
